import React from "react";
import { useStyles } from '../alerts/styles'
import { Box } from '@mui/material'
import GlobalNotificationHeader from './GlobalNotificationHeader/GlobalNotificationHeader'
import GlobalNotificationTabView from './GlobalNotificationTabView/GlobalNotificationTabView'

const GlobalNotification = () => {
    const { classes } = useStyles()
    return (
        <Box className={classes.alertContainer}>
            <GlobalNotificationHeader />
            <GlobalNotificationTabView />
        </Box>
    )
};
export default GlobalNotification;
